/**
 *  initial ROUTES
 */

export const HOME = '/'
export const SHOP = '/shop'
export const SIGNIN = '/signin'
export const SIGNUP = '/signup'
export const SIGNOUT = '/signout'
export const ACCOUNT = '/account'

/*
 *  Categories
 * */

export const CATEGORIES = '/shop/:category'
export const CATEGORY = '/shop/:category/:product'
